const createImage = (url: string) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

const safeAreaParameter = 2;

function getRadianAngle(degreeValue: number) {
  return (degreeValue * Math.PI) / 180;
}

export function blobToFile(theBlob: Blob, fileName: string): File {
  return new File([theBlob], fileName, { type: 'image/png' });
}

export function dataURLtoFile(dataurl: string, filename: string) {
  const arr = dataurl.split(',');
  const mime = (arr as any)[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export async function getCroppedImg(
  imageSrc: any,
  pixelCrop: any,
  rotation = 0,
) {
  const image: any = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx: any = canvas.getContext('2d');

  const safeArea = Math.max(image.width, image.height) * safeAreaParameter;

  canvas.width = safeArea;
  canvas.height = safeArea;

  (ctx as CanvasRenderingContext2D).translate(safeArea / safeAreaParameter, safeArea / safeAreaParameter);
  (ctx as CanvasRenderingContext2D).rotate(getRadianAngle(rotation));
  (ctx as CanvasRenderingContext2D).translate(-safeArea / safeAreaParameter, -safeArea / safeAreaParameter);
  (ctx as CanvasRenderingContext2D).drawImage(
    image,
    safeArea / 2 - image.width / safeAreaParameter,
    safeArea / 2 - image.height / safeAreaParameter,
  );
  const data = (ctx as CanvasRenderingContext2D).getImageData(
    0,
    0,
    safeArea,
    safeArea,
  );

  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  (ctx as CanvasRenderingContext2D).putImageData(
    data,
    0 - safeArea / safeAreaParameter + image.width / safeAreaParameter - pixelCrop.x,
    0 - safeArea / safeAreaParameter + image.height / safeAreaParameter - pixelCrop.y,
  );

  return canvas.toDataURL('image/jpeg', 0.5);
}
